import React, { Component } from 'react';

class NoIndex extends Component {

	render() {
		return (
			<meta name="robots" content="noindex">
			</meta>
		);
	}

}

export default NoIndex;


// WEBPACK FOOTER //
// ./src/components/SEO/NoIndex.js